export const messages = window.trans;



// WEBPACK FOOTER //
// ./src/translations.js